import React from 'react';
import i18n from '@i18n';

import { useReframe } from 'nike-re-framejs';
import PrematchDetail from '../components/PrematchDetail';
import { PrematchEventDetailPending } from '../components/EventDetailPending';
import NikeOneContext from '../context/NikeOneContext';
import DataStateEnum from '@/common/dataState';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import { detailDataState$, nikeoneDetailSportEventSportId$ } from '@/nikeone/subs-detail';
import { useNikeoneEventLoad } from '@/nikeone/handlers-detail';
import { NIKE1, NIKE1_MATCH } from '@/routing/routes';
import { Redirect } from 'react-router-dom';
import { CURRENT_PAGE, TURBO_LIVE_ROOT_PATH } from 'nike-ui/src/common/routing';
import SimplePageHeader from '@/header/SimplePageHeader';
import { navigate } from '@/routing';
import { fireGAEvent } from '@/analytics';
import { Footer } from '@/common/components/footer';
import { getSportNameById } from 'nike-ui/src/common/utils/utils';

function NikeOneDetail({ sportEventId }) {
    useNikeoneEventLoad(sportEventId);

    const derefSub = useReframe();
    const dataState = derefSub(detailDataState$(sportEventId));

    function goToPrematch() {
        navigate(NIKE1);
        fireGAEvent(CURRENT_PAGE, 'Prechod do ponuky');
    }

    if (dataState === DataStateEnum.PENDING) {
        return <PrematchEventDetailPending />;
    }
    const matchIsLive = derefSub(['nikeone.detail.isLive']);
    const sportEventLiveId = derefSub(['nikeone.detail.sportEventId']);
    const sportId = derefSub(nikeoneDetailSportEventSportId$);
    //tripple protection - you never know... bez ohladu na URL z odkial z akej url. a pod user pride - zobrazime mu nejaky dostupny content - nezobrazime ho jedine ze uz realne ziadny dostupny nie je
    if (matchIsLive || (dataState === DataStateEnum.EMPTY && !sportEventLiveId)) {
        const seId = sportEventId || sportEventLiveId;
        const sportName = getSportNameById(sportId);
        //spravil som to cez redirect - moze to vyzerat trosku divne pri prechode z prematchu do TLV, ale dostat sem TLV detail by bolo pekne problematicke :/
        return <Redirect from={NIKE1_MATCH.path} to={TURBO_LIVE_ROOT_PATH + '/' + sportName + '/' + seId} />;
    }

    if (dataState === DataStateEnum.EMPTY) {
        return (
            <>
                <SimplePageHeader />
                <EmptyState
                    text={i18n('error.sportEvent.detail.nodata')}
                    buttonOnClick={goToPrematch}
                    buttonClassName="light-button"
                    buttonText={i18n('go-to-prematch')}
                />
                <Footer />
            </>
        );
    }

    return <PrematchDetail eventId={sportEventId} />;
}

export default NikeOneDetail;

NikeOneDetail.contextType = NikeOneContext;
